export default "__VITE_ASSET__BCzI625r__"